<template>
  <div class="sidebar-container" :class="{'is-active':isCollapse}">
    <logo :isCollapse="isCollapse"></logo>
    <div class="menu-body">
      <el-menu :unique-opened="uniqueOpened" :default-active="nowTagValue" mode="vertical" :collapse="isCollapse">
        <sidebar-item :menuData="menu" :isCollapse="isCollapse" :show-icon="true"></sidebar-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { setUrlPath } from '@/util/util';
import { mapGetters } from 'vuex';
import SidebarItem from './sidebarItem';
import logo from './logo';
import { deepCopy, getAuthorizedMenu } from '@/util/util';

export default {
  name: 'sidebar',
  components: { logo,SidebarItem },
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      localMenu: [],
      uniqueOpened: true,
    };
  },
  computed: {
    ...mapGetters(['isCollapse','pms', 'menu','opened','memberInfo', 'accessToken', 'permissionAddRoutes']),
    nowTagValue() {
      return setUrlPath(this.$route);
    }
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
  .sidebar-container {
    width: 210px;
    overflow: hidden;
    position: relative;
    background: #FFFFFF;
    border-right: 1px solid #E8E8E8;
    transition: width .6s;
    
    &.is-active {
      width: 64px !important;
    }
    .menu-body {
      width: 100%;
      height: calc(100vh - 64px);
      overflow-x: hidden;
      overflow-y: auto;
      .el-menu {
        border-right-width: 0;
      }
    }
  }
  .menu-body::-webkit-scrollbar {
    display: none;
  }
  .el-menu--collapse {
    ::v-deep .el-submenu.is-active {
      background: rgba(255,150,1,0.06) !important;
    }
    ::v-deep .el-submenu__icon-arrow {
      display: none;
    }
  }
</style>
